import * as gsap from 'gsap'

import fade from '../utils/mixins/fade'
import slide from '../utils/mixins/slide'
import scale from '../utils/mixins/scale'
import rotate from '../utils/mixins/rotate'
import custom from '../utils/mixins/custom'

import symbolAnimation from '../utils/symbolAnimation'

export default {
  inject: { symbolAnimation },
  mixins: [
    fade,
    slide,
    scale,
    rotate,
    custom,
  ],

  props: {
    tag: {
      type: String,
      default: 'div',
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    animationType: {
      type: String,
      default: 'fadeIn',
    },
  },

  data: () => ({
    timeline: new gsap.TimelineMax(),
  }),

  mounted() {
    this[this.animationType]()
  },

  computed: {
    reverse() {
      return this.options.reverse
    },
    distance() {
      return this.options.distance || 100
    },
    scale() {
      return this.options.scale || 0.1
    },
    rotation() {
      return this.options.rotation || 45
    },
    opacity() {
      return `${this.options.opacity}` || 1
    },
    pause() {
      return this.options.pause ? null : 0
    },
    easeType() {
      return this.options.easeType || 'Power3'
    },
    easeMode() {
      return this.options.easeMode || 'easeInOut'
    },
    ease() {
      return gsap[this.easeType][this.easeMode] || gsap.Power1.easeInOut
    },
  },

  methods: {
    animation(type, ...attrs) {
      this.timeline[type](
        this.$el,
        this.options.duration || 1,
        ...attrs,
        this.options.delay || 0,
      )
    },

    animationFrom(...attrs) {
      this.animation('from', ...attrs)
    },
    animationTo(...attrs) {
      this.animation('to', ...attrs)
    },
    animationFromTo(...attrs) {
      this.animation('fromTo', ...attrs)
    },

    handleIsIntersecting(intersecting) {
      const { timeline } = this
      if (this.reverse) {
        return intersecting ? timeline.reverse() : timeline.play()
      }
      return intersecting ? timeline.play() : timeline.pause(this.pause)
    },
  },

  // watches base animation component and fires handler
  // when the wrapper is intersected on screen (viewport)
  watch: {
    'symbolAnimation.previousIsIntersecting': 'handleIsIntersecting',
  },

  render(h) {
    return h(this.tag, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/components/BaseAnimationItem.js